import React, { useState, useEffect } from 'react';
import { FaFolderOpen, FaChevronDown, FaChevronRight, FaShare, FaTrash, FaClock, FaFile } from 'react-icons/fa';
import { fileService } from '../services/api';
import { toast } from 'react-toastify';

const TempFoldersList = ({ onSelectFolder, onManageFolder, refreshTrigger }) => {
  const [expanded, setExpanded] = useState(false);
  const [tempFolders, setTempFolders] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadTempFolders = async () => {
    setLoading(true);
    try {
      const result = await fileService.getSharedLinks();
      if (result.success) {
        setTempFolders(result.sharedLinks || []);
      }
    } catch (error) {
      console.error('Error cargando carpetas temporales:', error);
      toast.error('Error al cargar carpetas temporales', { autoClose: 2000 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (expanded) {
      loadTempFolders();
    }
  }, [expanded]);

  // Refrescar automáticamente cuando cambia refreshTrigger (cuando se crea un nuevo link compartido)
  useEffect(() => {
    if (refreshTrigger && refreshTrigger > 0) {
      // Expandir automáticamente la sección si está colapsada
      if (!expanded) {
        setExpanded(true);
      }
      // Cargar los links compartidos
      loadTempFolders();
    }
  }, [refreshTrigger]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = date - now;
    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    
    if (diffDays < 0) {
      return 'Expirado';
    } else if (diffDays === 0) {
      return 'Hoy';
    } else if (diffDays === 1) {
      return 'Mañana';
    } else {
      return `${diffDays} días`;
    }
  };

  const handleDelete = async (e, token) => {
    e.stopPropagation();
    if (!window.confirm('¿Estás seguro de que quieres eliminar esta carpeta temporal?')) {
      return;
    }

    try {
      const result = await fileService.deleteSharedLink(token);
      if (result.success) {
        toast.success('Carpeta temporal eliminada', { autoClose: 2000 });
        loadTempFolders();
      }
    } catch (error) {
      console.error('Error eliminando carpeta temporal:', error);
      toast.error('Error al eliminar carpeta temporal', { autoClose: 2000 });
    }
  };

  const handleCopyLink = async (e, publicUrl) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(publicUrl);
      toast.success('Link copiado al portapapeles', { autoClose: 2000 });
    } catch (error) {
      console.error('Error copiando link:', error);
      toast.error('Error al copiar link', { autoClose: 2000 });
    }
  };

  return (
    <div className="mt-6">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-4 py-3 rounded-lg text-left text-sidebar-text hover:bg-gray-700 hover:text-white transition-colors"
      >
      
        <span className="font-medium">Material compartido</span>
  
        {expanded ? (
          <FaChevronDown className="text-sm" />
        ) : (
          <FaChevronRight className="text-sm" />
        )}
      </button>

      {expanded && (
        <div className="ml-4 mt-2 space-y-1 max-h-[30vh] overflow-y-auto">
          {loading ? (
            <div className="flex items-center space-x-2 px-2 py-1 text-sm text-gray-400">
              <div className="w-4 h-4 border border-gray-400 border-t-transparent rounded-full animate-spin"></div>
              <span>Cargando...</span>
            </div>
          ) : tempFolders.length > 0 ? (
            tempFolders.map((folder) => (
              <div
                key={folder.token}
                className="group flex items-center justify-between px-2 py-1 rounded-lg hover:bg-gray-700 transition-colors"
              >
                <button
                  onClick={() => {
                    if (onManageFolder) {
                      onManageFolder(folder);
                    }
                  }}
                  className="flex-1 flex items-center space-x-2 text-left text-sm text-gray-300 hover:text-white transition-colors min-w-0"
                >
                  {folder.isSingleFile ? (
                    <FaFile className="text-blue-400 flex-shrink-0" />
                  ) : (
                    <FaFolderOpen className="text-purple-400 flex-shrink-0" />
                  )}
                  <div className="flex-1 min-w-0">
                    <div className="truncate">
                      {folder.folderName || `${folder.fileCount} archivo${folder.fileCount !== 1 ? 's' : ''}`}
                    </div>
                    <div className="flex items-center space-x-2 text-xs text-gray-500 mt-0.5">
                      <FaClock className="text-xs" />
                      <span>{formatDate(folder.expiresAt)}</span>
                      {folder.hasPassword && (
                        <span className="text-yellow-400">🔒</span>
                      )}
                    </div>
                  </div>
                </button>
                <div className="flex items-center space-x-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button
                    onClick={(e) => handleCopyLink(e, folder.publicUrl)}
                    className="p-1 text-gray-400 hover:text-blue-400 transition-colors"
                    title="Copiar link"
                  >
                    <FaShare className="text-xs" />
                  </button>
                  <button
                    onClick={(e) => handleDelete(e, folder.token)}
                    className="p-1 text-gray-400 hover:text-red-400 transition-colors"
                    title="Eliminar"
                  >
                    <FaTrash className="text-xs" />
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="px-2 py-1 text-sm text-gray-400">
              No hay carpetas temporales
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TempFoldersList;
